import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Breadcrumb from './breadcrumb/breadcrumb';

globalThis.React = React;
globalThis.ReactDOM = ReactDOM;
globalThis.Breadcrumb = Breadcrumb;
globalThis.ReactDOMServer = ReactDOMServer;
